import { createApp } from 'vue'
import AppMain from './App'
import AppError from './AppError'
import router from './mainRouter'
import axios from 'axios'
import { useCompanyStore } from '@/stores/company'

import '@/scss/_main.scss'

import { createPinia } from 'pinia'
let pinia = createPinia();

(async () => {
  try {
    let response;

    /**
     * Если установлен legacySysObject, значит приложение открыто из битрикса
     *   и можно пропустить шаг запроса к серверу на проверку адресной строки
     *
     * Если legacySysObject не задан, то нужно вызвать API-метод dealCheck и отправить
     *   субдомен и уникальный адрес ссылки для поиска его в битриксе
     */
    if (!window?.legacySysObject) {
      // Ищем уникальную часть ссылки Сделки
      let pathSegments = window.location.pathname.split('/'),
        deal = pathSegments[1]

      // Определяем субдомен
      let subDomain = 'dbogdanoff'
      if (process.env.NODE_ENV !== 'development') {
        subDomain = '';
        const parts = window.location.hostname.split('.');

        // Проверяем, есть ли в hostname ровно три компонента
        if (parts.length === 3) {
          // Домен третьего уровня будет первым элементом массива
          subDomain = parts[0];
        } else {
          throw new Error('Домен не найден');
        }
      } else {
        deal = 'plod'
      }

      // Делаем API запрос
      axios.defaults.baseURL = process.env.NODE_ENV === 'development' ? 'https://boardx24.ru/' : ''
      response = await axios.get('/api/dealCheck', {
        params: {
          deal,
          subDomain
        }
      })

      if (!response.data.success) {
        throw new Error(response.data.errorMessage)
      }
    }

    createApp(AppMain)
      .use(pinia)
      .use(router)
      .mount('#app')

    // Устанавливаем в companyStore системные значения портала, клиента и компании
    let companyStore = useCompanyStore()
    if (!window?.legacySysObject && response.data.success) {
      companyStore.setSysObject(response.data)
    } else if (window?.legacySysObject) {
      companyStore.setSysObject(window.legacySysObject)
    }
  }
  catch (error) {
    const app = createApp(AppError)
    app.use(pinia)
    app.mount('#app')

    let companyStore = useCompanyStore()
    companyStore.setErrorMessage(error.message)
  }
})();
